import React from "react";
import { Store, Building2, Briefcase, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

const GROUPS = [
  {
    icon: Store,
    code: "GRP-01",
    title: "Freie Händler & GW-Zentren",
    desc: "Sie haben Bestand, aber keine Pflege-Ressourcen für Feed-Qualität und SEO-Logik. Wir übernehmen die komplette Datenarbeit.",
    bullets: ["Bis 1.500 Fahrzeuge", "1 Standort", "Service-Setup in 14 Tagen"],
  },
  {
    icon: Building2,
    code: "GRP-02",
    title: "Händlergruppen",
    desc: "Mehrere Marken, mehrere Standorte, mehrere DMS. Wir vereinheitlichen Datenmodell, Feed-Logik und SEO-Architektur zentral.",
    bullets: ["Multi-Standort-Governance", "Marken-übergreifend", "Group-Reporting"],
  },
  {
    icon: Briefcase,
    code: "GRP-03",
    title: "Agenturen & Dienstleister",
    desc: "Sie liefern Performance, wir liefern die Datenbasis. White-Label-Modell mit eigener Marke, voller Infrastruktur im Hintergrund.",
    bullets: ["White-Label-Service", "Reseller-Modell", "API-Anbindung"],
  },
];

export default function Zielgruppen() {
  return (
    <SectionContainer id="zielgruppen" className="bg-white">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <SectionLabel number="/ 10" label="Zielgruppen" />
          <SectionHeading>Für wen wir das machen.</SectionHeading>
          <SectionLead>
            Wir arbeiten mit Händlern, die Bestand haben, aber keine Datenpipeline.
            Mit Gruppen, die Skalierung suchen. Und mit Partnern, die uns als Infrastruktur einsetzen.
          </SectionLead>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {GROUPS.map((g, idx) => {
          const Icon = g.icon;
          return (
            <article key={g.code} data-testid={`zielgruppe-${idx}`} className="group relative bg-white border border-slate-200 rounded-lg ring-soft p-7 hover:border-slate-300 transition-all">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center justify-center size-10 rounded-md bg-slate-50 border border-slate-200">
                  <Icon className="size-4 text-cyan-600" />
                </span>
                <span className="label-mono text-slate-400">{g.code}</span>
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-slate-900">{g.title}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{g.desc}</p>
              <ul className="mt-5 space-y-1.5">
                {g.bullets.map((b) => (
                  <li key={b} className="font-mono text-[12px] text-slate-500 flex items-center gap-2">
                    <span className="size-1.5 rounded-full bg-cyan-500" /> {b}
                  </li>
                ))}
              </ul>
              <Link to={idx === 2 ? "/white-label" : "/audit"} className="mt-7 inline-flex items-center gap-1.5 text-sm font-medium text-cyan-700 hover:text-cyan-800">
                Passenden Einstieg ansehen <ArrowUpRight className="size-3.5" />
              </Link>
            </article>
          );
        })}
      </div>
    </SectionContainer>
  );
}
